/**
 * @ngdoc object
 * @name picklists
 * @description
 *
 */
angular
    .module('festzelt-os.shippings', [
        'ui.router',
        'festzelt-os.components'
    ]);

require('./shippings-routes');

// Controllers
require('./controllers/details-controller');
require('./controllers/list-controller');
require('./controllers/edit-address-modal-controller');

// Factories
require('./factories/shipping-factory');

// Store
require('./store/shippings');

// Workflows
require('./workflows/list/update-shipping-settings');



// WEBPACK FOOTER //
// ./src/app/pages/shippings/shippings-module.js